module.exports = __webpack_public_path__ + "static/media/paypal.aaffab32.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/paypal.png
// module id = 526
// module chunks = 0